module.exports = __webpack_public_path__ + "static/media/ic-back.4ce0a612.svg";